import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, createBlock as _createBlock } from "vue";
import _imports_0 from '../../assets/images/guide-step3.png';
const _hoisted_1 = {
  key: 0,
  class: "guide-dialog"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  class: "header-text"
}, "版本更新啦～", -1);
const _hoisted_4 = {
  class: "gif-wrap"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "功能位置迁移", -1);
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", {
  class: "description"
}, " 左侧功能入口现已切换到顶部，可点击顶部按钮查看相应页面。 ", -1);
const _hoisted_8 = {
  class: "gif-wrap"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "更快查看收藏", -1);
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", {
  class: "description"
}, [/*#__PURE__*/_createTextVNode(" 一点即筛，简单直接。可通过点击“"), /*#__PURE__*/_createElementVNode("span", {
  class: "description-step2"
}, " 只看我的收藏 "), /*#__PURE__*/_createTextVNode("”快速查看收藏内容。 ")], -1);
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "gif-wrap"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "gif"
}), /*#__PURE__*/_createElementVNode("p", {
  class: "gif-description"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "old-system system"
}, "旧系统"), /*#__PURE__*/_createElementVNode("span", {
  class: "new-system system"
}, "新系统")])], -1);
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "删除内容一目了然", -1);
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", {
  class: "description"
}, " 删除内容统一存放，恢复/管理一键解决，再也不怕意外删除啦 ", -1);
const _hoisted_15 = {
  class: "item-footer"
};
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  class: "wx-link cursor"
}, "ydy-service", -1);
const _hoisted_17 = {
  class: "arrows"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item");
  const _component_el_carousel = _resolveComponent("el-carousel");
  const _component_ContactUs = _resolveComponent("ContactUs");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createBlock(_Transition, {
    name: "scale-fade-bg"
  }, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", {
      class: "guide-dialog-wrap",
      onClick: _cache[3] || (_cache[3] = _withModifiers(
      //@ts-ignore
      (...args) => _ctx.handleClose && _ctx.handleClose(...args), ["self"]))
    }, [_createVNode(_Transition, {
      name: "scale-fade"
    }, {
      default: _withCtx(() => [_ctx.state.guideVisible ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("i", {
        class: "jdl-icon-close",
        onClick: _cache[0] || (_cache[0] =
        //@ts-ignore
        (...args) => _ctx.handleClose && _ctx.handleClose(...args))
      })]), _createVNode(_component_el_carousel, {
        interval: 5000,
        autoplay: true,
        onChange: _ctx.handleChange,
        arrow: "never",
        ref: "carouselDom",
        "initial-index": 0
      }, {
        default: _withCtx(() => [_createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("video", {
            src: _ctx.state.step1,
            autoplay: "",
            loop: "",
            class: "gif"
          }, null, 8, _hoisted_5)]), _hoisted_6, _hoisted_7]),
          _: 1
        }), _createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createElementVNode("video", {
            src: _ctx.state.step2,
            autoplay: "",
            loop: "",
            class: "gif"
          }, null, 8, _hoisted_9)]), _hoisted_10, _hoisted_11]),
          _: 1
        }), _createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [_hoisted_12, _hoisted_13, _hoisted_14]),
          _: 1
        })]),
        _: 1
      }, 8, ["onChange"]), _createElementVNode("div", _hoisted_15, [_createElementVNode("p", null, [_createTextVNode(" 新系统操作如有问题，可添加微信： "), _createVNode(_component_ContactUs, {
        useDefault: false
      }, {
        default: _withCtx(() => [_hoisted_16]),
        _: 1
      })]), _createElementVNode("p", null, [_createVNode(_component_el_button, {
        onClick: _ctx.handleMore,
        type: "info"
      }, {
        default: _withCtx(() => [_createTextVNode("了解更多")]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.handleClose
      }, {
        default: _withCtx(() => [_createTextVNode("我知道了")]),
        _: 1
      }, 8, ["onClick"])])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", {
        class: _normalizeClass(`arrows-left ${_ctx.state.activeIndex === 0 && 'disabled'}`),
        onClick: _cache[1] || (_cache[1] =
        //@ts-ignore
        (...args) => _ctx.handlePre && _ctx.handlePre(...args))
      }, null, 2), _createElementVNode("div", {
        class: _normalizeClass(`arrows-right ${_ctx.state.activeIndex === 2 && 'disabled'}`),
        onClick: _cache[2] || (_cache[2] =
        //@ts-ignore
        (...args) => _ctx.handleNext && _ctx.handleNext(...args))
      }, null, 2)])])) : _createCommentVNode("", true)]),
      _: 1
    })], 512), [[_vShow, _ctx.state.guideVisible]])]),
    _: 1
  });
}